import { FC, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form';
import { Textarea, TextareaProps } from '../ui/textarea';
import { cn } from '@/lib/utils';

interface IShadCnFormTextareaProps extends TextareaProps {
  name: string;
  placeholder?: string;
  disabled?: boolean;
  label?: ReactNode;
  description?: ReactNode;
}

const ShadCnFormTextarea: FC<IShadCnFormTextareaProps> = ({
  name,
  label,
  className,
  description,
  ...rest
}) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn('w-full', className)}>
          {!!label && <FormLabel>{label}</FormLabel>}
          {!!description && <p className='text-sm text-gray-600'>{description}</p>}
          <FormControl>
            <Textarea {...field} {...rest} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ShadCnFormTextarea;
